import React, { useRef, useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToBuild() {
  const sectionRef = useRef<HTMLElement>(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!sectionRef.current) return;
    if (window.innerWidth < 768) return;
    const {
      left,
      top,
      width,
      height
    } = sectionRef.current.getBoundingClientRect();
    const x = e.clientX - left - width / 2;
    const y = e.clientY - top - height / 2;
    setPosition({
      x: x * 0.4,
      y: y * 0.4
    });
  };
  const handleMouseLeave = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="47836" id="ready-for-an-upgrade" ref={sectionRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className="dark bg-background text-foreground relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,hsl(222,47%,11%)_0%,hsl(222,47%,4%)_70%)] opacity-90" />

      {}
      <div ref={textRef} className={cn("absolute inset-0 flex flex-col items-center justify-center pointer-events-none select-none z-0 transition-all duration-1000 ease-out", textVisible ? "opacity-100 scale-100" : "opacity-0 scale-95")}>
        <h2 className="w-full text-center leading-[0.85] tracking-tighter">
          <span className="block text-[12vw] font-black text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.1)] md:[-webkit-text-stroke:2px_rgba(255,255,255,0.1)]">
            READY FOR
          </span>
          <span className="block text-[12vw] font-black text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.1)] md:[-webkit-text-stroke:2px_rgba(255,255,255,0.1)]">
            AN
          </span>
          <span className="block text-[12vw] font-black text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.1)] md:[-webkit-text-stroke:2px_rgba(255,255,255,0.1)]">
            UPGRADE?
          </span>
        </h2>
      </div>

      {}
      <div className="relative z-10 transition-transform duration-100 ease-out will-change-transform" style={{
      transform: `translate(${position.x}px, ${position.y}px)`
    }}>
        <Button asChild className="h-48 w-48 rounded-full border-2 border-white/20 bg-destructive text-white backdrop-blur-md shadow-2xl transition-all duration-300 hover:scale-110 hover:bg-destructive/90 hover:border-white/40 hover:shadow-[0_0_60px_rgba(220,38,38,0.5)] md:h-64 md:w-64">
          <Link to="/ContactPage" className="flex flex-col items-center justify-center gap-2 text-center">
            <span className="text-lg font-bold tracking-widest md:text-xl">GET AN</span>
            <span className="text-lg font-bold tracking-widest md:text-xl">INSTANT QUOTE</span>
            <ArrowRight className="mt-2 h-6 w-6 animate-pulse text-white" />
          </Link>
        </Button>
      </div>
    </section>;
}